import { render, staticRenderFns } from "./carouselDialog.vue?vue&type=template&id=80772418&scoped=true"
import script from "./carouselDialog.vue?vue&type=script&lang=js"
export * from "./carouselDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80772418",
  null
  
)

export default component.exports